import {PublicPageStyle} from "../../constants/styles";
import PublicTemplate from "../publics/PublicTemplate";
import styled from "styled-components";

import {Button, message, Select, Table} from "antd";
import {LsEditModal} from "../organisms/lottesuper/LSEditModal";
import {useEffect, useState} from "react";
import axios from "axios";
import {useLsLight} from "../../hooks/lottesuper/use-ls-light";
import {useLsWg} from "../../hooks/lottesuper/use-ls-wg";

const LotteSuperAdminPage = () => {
    const [stores, setStores] = useState<{no: number; name: string}[]>([]);
    const [zoneNo, setZoneNo] = useState<number | null>(null);
    const [modal, setModal] = useState<"WG" | "LIGHT" | false>(false);
    const [name, setName] = useState<string | null>(null);

    const {wgList, getWgList, wgLoading} = useLsWg({zoneNo});
    const {lightList, lightLoading, getLightList} = useLsLight({zoneNo});

    const handleDelete = (id: number) => {
        const confirm = window.confirm("삭제하시겠습니까?");
        if (confirm) {
            message.success("삭제되었습니다.");
        }
    };

    const getStores = async () => {
        try {
            const res = await axios.get(`${process.env.REACT_APP_LS_API_URL}/stores`);
            if (res.data) setStores(res.data);
        } catch (e) {
            console.log(e);
        }
    };

    const handleRefresh = async () => {
        // 새로고침
        await getLightList();
    };

    useEffect(() => {
        getStores();
    }, []);
    useEffect(() => {
        if (zoneNo) getLightList();
    }, [zoneNo]);

    return (
        <PublicPageStyle>
            {modal && (
                <LsEditModal
                    close={() => {
                        setModal(false);
                        setName(null);
                    }}
                    type={modal}
                    name={name}
                    zoneNo={zoneNo}
                    stores={stores}
                />
            )}
            <PublicTemplate>
                <Container>
                    <h3>롯데슈퍼 관리자 사이트</h3>
                    <FilterArea>
                        <Filter>
                            <label>지점</label>
                            <Select
                                className={"inputs"}
                                placeholder={"지점 선택"}
                                size={"large"}
                                value={zoneNo}
                                onChange={(e) => setZoneNo(e)}
                                options={[
                                    {
                                        label: "전체",
                                        value: null,
                                    },
                                    ...stores.map((item) => ({label: item.name + ` (${item.no})`, value: item.no})),
                                ]}
                                showSearch
                                filterOption={(input, option) => {
                                    if (option && typeof option.label === "string") {
                                        return option.label.toLowerCase().includes(input.toLowerCase());
                                    }
                                    return false;
                                }}
                            />
                        </Filter>
                        <Button onClick={handleRefresh}>새로고침</Button>
                    </FilterArea>
                    <TableContainer>
                        <span className={"table-title"}>
                            WG
                            <Button className={"button"} onClick={() => setModal("WG")}>
                                추가하기
                            </Button>
                        </span>
                        <span className={"table-title"}>
                            조명
                            <Button className={"button"} onClick={() => setModal("LIGHT")}>
                                추가하기
                            </Button>
                        </span>
                        <Table
                            className={"table wg-table"}
                            bordered
                            pagination={false}
                            loading={wgLoading}
                            rowKey={"no"}
                            dataSource={[
                                {
                                    no: 1,
                                    name: "-",
                                },
                            ]}
                            columns={[
                                {
                                    title: "no",
                                    dataIndex: "no",
                                    align: "center",
                                    width: "5%",
                                },
                                {
                                    title: "zoneNo",
                                    dataIndex: "zoneNo",
                                    width: "5%",
                                },
                                {
                                    title: "id",
                                    dataIndex: "id",
                                },
                                {
                                    title: "name",
                                    dataIndex: "name",
                                },
                                {
                                    title: "수정/삭제",
                                    dataIndex: "no",
                                    align: "center",
                                    width: "8%",
                                    render: (value) => (
                                        <div className={"table-button-container"}>
                                            <Button
                                                className={"update-button"}
                                                onClick={() => {
                                                    setModal("WG");
                                                    setName(value);
                                                }}
                                                size={"small"}
                                            >
                                                수정
                                            </Button>
                                            <Button
                                                className={"delete-button"}
                                                onClick={() => handleDelete(1)}
                                                size={"small"}
                                            >
                                                삭제
                                            </Button>
                                        </div>
                                    ),
                                },
                            ]}
                        />
                        <Table
                            className={"table"}
                            bordered
                            rowKey={"no"}
                            pagination={false}
                            dataSource={lightList}
                            loading={lightLoading}
                            columns={[
                                {
                                    title: "no",
                                    dataIndex: "no",
                                    align: "center",
                                },
                                {
                                    title: "zoneNo",
                                    dataIndex: "zoneNo",
                                    align: "center",
                                },
                                {
                                    title: "WG id",
                                    dataIndex: "wgId",
                                },
                                {
                                    title: "lineNo",
                                    dataIndex: "lineNo",
                                },
                                {
                                    title: "subNo",
                                    dataIndex: "subNo",
                                },
                                {
                                    title: "name",
                                    dataIndex: "name",
                                },
                                {
                                    title: "lineType",
                                    dataIndex: "lineType",
                                },
                                {
                                    title: "isOutdoor",
                                    dataIndex: "isOutdoor",
                                },
                                {
                                    title: "order",
                                    dataIndex: "order",
                                },
                                {
                                    title: "수정/삭제",
                                    dataIndex: "name",
                                    align: "center",
                                    width: "8%",
                                    render: (value) => (
                                        <div className={"table-button-container"}>
                                            <Button
                                                className={"update-button"}
                                                onClick={() => {
                                                    setModal("LIGHT");
                                                    setName(value);
                                                }}
                                                size={"small"}
                                            >
                                                수정
                                            </Button>
                                            <Button className={"delete-button"} size={"small"}>
                                                삭제
                                            </Button>
                                        </div>
                                    ),
                                },
                            ]}
                        />
                    </TableContainer>
                </Container>
            </PublicTemplate>
        </PublicPageStyle>
    );
};

export {LotteSuperAdminPage};

const Container = styled.div`
    width: 100%;
    padding: 0 30px 30px;
`;

const FilterArea = styled.div`
    width: 100%;
    //height: 100px;
    border-bottom: 2px solid #e8e8e8;
    padding-bottom: 24px;
    display: flex;
    align-items: end;
`;

const Filter = styled.div`
    width: 200px;
    display: flex;
    flex-wrap: wrap;
    align-items: center;

    label {
        width: 100%;
        margin-bottom: 12px;
    }

    .inputs {
        width: 90%;
    }
`;

const TableContainer = styled.div`
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    padding-top: 24px;
    padding-bottom: 100px;

    .table-title {
        width: 69%;
        display: flex;
        align-items: center;
        font-size: 24px;
        margin-bottom: 12px;

        .button {
            margin-left: 10px;
            border: 2px solid #698fe1;
        }

        &:first-child {
            width: 30%;
        }
    }

    .table {
        width: 69%;

        th {
            background-color: #d8d8d8 !important;
            padding: 12px !important;
        }

        .table-button-container {
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 8px;

            .update-button {
                border: 2px solid #698fe1 !important;
                color: #698fe1;
            }

            .delete-button {
                border: 2px solid #e16969 !important;
                color: #e16969;
            }
        }
    }

    .wg-table {
        width: 30%;
    }
`;
